import { ProcessObject } from '../process-objects/list/types';

export type StartCalibrationTaskRequest = {
	metadata: {
		measurementGroupId: number;
		startTime: string;
		endTime: string;
		intercept: boolean;
		processObjects: CalibrationTaskProcessObject[];
	};
	referenceDataFile: File | null;
	historicalDataFile?: File | null;
};

export type CalibrationTaskProcessObject = Omit<ProcessObject, 'trmsLimit' | 'relationsDetails'> & {
	primaryCalibrationFactor: number;
};

export enum TaskType {
	GET_DATA = 'GET_DATA',
	CROSS_VALIDATION = 'CROSS_VALIDATION',
	UNIT_VECTOR = 'UNIT_VECTOR',
	REVISION_DATA = "REVISION_DATA"
}

export enum CalibrationOperationType {
	GET_DATA = TaskType.GET_DATA,
	CROSS_VALIDATION = TaskType.CROSS_VALIDATION,
	UNIT_VECTOR = TaskType.UNIT_VECTOR
}
